import {omit} from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {findAnswerOrFolderNestingLevel} from '../../helpers/models/answerHelpers';
import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {AnswerFolderModel} from '../../models/api/answerFolderModel';
import {AppState} from '../../store/appState';
import {getAnswerFolders} from '../../store/data/answerFolders/answerFolderSelectors';
import {SettingsAnswersTableFolderNameCell} from './settingsAnswersTableFolderNameCell';

/*
 * Props.
 */

interface SettingsAnswersTableFolderNameCellContainerProps {
  value: AnswerFolderModel;
  parentFolderId?: number;
}

/*
 * Selectors.
 */

function getValue(_state: AppState, props: SettingsAnswersTableFolderNameCellContainerProps) {
  return props.value;
}

function getParentFolderId(_state: AppState, props: SettingsAnswersTableFolderNameCellContainerProps) {
  return props.parentFolderId;
}

function makeGetNestingLevel() {
  return createSelector(
    [getValue, getAnswerFolders, getParentFolderId],
    (value, answerFolders, parentFolderId) =>
      findAnswerOrFolderNestingLevel(value, omit(answerFolders, parentFolderId || 0), 0),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAnswersTableFolderNameCellContainerProps>()(() => ({
  nestingLevel: makeGetNestingLevel(),
}));

export const SettingsAnswersTableFolderNameCellContainer = connect(mapStateToProps)(
  SettingsAnswersTableFolderNameCell,
);
